<template>
	<section class="section--floating section--flexed">
		<div class="flex gap-2 content-between items-center">
			<h2 class="beta">Client Details</h2>
			<!--			<v-contextual>-->
			<!--				<v-contextual-option>Button</v-contextual-option>-->
			<!--			</v-contextual>-->
		</div>
		<div class="mt-2 sections">
			<dl class="section section--flat flex gap-4">
				<div>
					<div class="flex gap-1 items-center">
						<dt class="icon--contact--email">Email</dt>
						<dd v-if="!client.email">—</dd>
						<dd v-else v-html="client.email"/>
					</div>
					<div class="flex gap-1 items-center mt-1">
						<dt class="icon--contact--phone">Phone Number</dt>
						<dd v-if="!client.phone">—</dd>
						<dd v-else v-html="client.phone"/>
					</div>
				</div>
				<div>
					<div class="flex gap-1 items-start">
						<dt class="icon--contact--address">Correspondence Address</dt>
						<dd v-if="!client.correspondenceAddress">—</dd>
						<Address v-else :address="client.correspondenceAddress"/>
					</div>
				</div>
			</dl>
			<!--			<dl class="section section&#45;&#45;flat flex gap-4">-->
			<!--				&lt;!&ndash;				<div>&ndash;&gt;-->
			<!--				&lt;!&ndash;					<dt class="all-caps gamma">Next Appointment</dt>&ndash;&gt;-->
			<!--				&lt;!&ndash;					<dd v-if="!client.group.appointments[0]" class="alpha">—</dd>&ndash;&gt;-->
			<!--				&lt;!&ndash;					<dd v-else v-html="client.group.appointments[0].time" class="alpha"/>&ndash;&gt;-->
			<!--				&lt;!&ndash;					<dd class="mt-1">&ndash;&gt;-->
			<!--				&lt;!&ndash;						<button class="icon&#45;&#45;plus&#45;&#45;pink" @click.prevent>Add An Appointment</button>&ndash;&gt;-->
			<!--				&lt;!&ndash;					</dd>&ndash;&gt;-->
			<!--				&lt;!&ndash;				</div>&ndash;&gt;-->
			<!--				<div>-->
			<!--					<dt class="all-caps gamma">Calls</dt>-->
			<!--					<dd v-if="!client.group.calls.length" class="alpha" v-html="client.group.calls.length"/>-->
			<!--					<dd v-else>-->
			<!--						<button-->
			<!--							class="alpha highlight-text" v-html="client.group.calls.length"-->
			<!--							@click.prevent="showCallLogModal()"/>-->
			<!--					</dd>-->
			<!--					<dd v-if="!startingCall && !activeCall" class="mt-1">-->
			<!--						<button class="icon&#45;&#45;plus&#45;&#45;pink" @click.prevent="startNewCall()">Log A Call</button>-->
			<!--					</dd>-->
			<!--				</div>-->
			<!--				<div>-->
			<!--					<dt class="all-caps gamma">Notes</dt>-->
			<!--					<dd v-if="!client.group.notes.length" class="alpha" v-html="client.group.notes.length"/>-->
			<!--					<dd v-else>-->
			<!--						<button-->
			<!--							class="alpha highlight-text" v-html="client.group.notes.length"-->
			<!--							@click.prevent="showNotesModal()"/>-->
			<!--					</dd>-->
			<!--					<dd class="mt-1">-->
			<!--						<button class="icon&#45;&#45;plus&#45;&#45;pink" @click.prevent="showNotesModal(true)">Add A Note</button>-->
			<!--					</dd>-->
			<!--				</div>-->
			<!--				<div>-->
			<!--					<dt class="all-caps gamma">To-Dos</dt>-->
			<!--					<dd v-if="!client.group.todos.length" class="alpha" v-html="client.group.todos.length"/>-->
			<!--					<dd v-else>-->
			<!--						<button-->
			<!--							class="alpha highlight-text" v-html="client.group.todos.length"-->
			<!--							@click.prevent="showToDosModal()"/>-->
			<!--					</dd>-->
			<!--					<dd class="mt-1">-->
			<!--						<button class="icon&#45;&#45;plus&#45;&#45;pink" @click.prevent="showToDosModal(true)">Add A ToDo</button>-->
			<!--					</dd>-->
			<!--				</div>-->
			<!--			</dl>-->
		</div>
	</section>
</template>
<script>
import {mapActions, mapState} from "vuex";
import Address from "../../../../components/Address.vue";

export default {
	components: {
		Address,
	},

	computed: {
		...mapState("activeCall", [
			"startingCall",
			"activeCall",
			"callDuration",
		]),
	},

	methods: {
		...mapActions("activeCall", [
			"startCall",
		]),
		startNewCall() {
			this.startCall(this.client);
		},
		showCallLogModal() {
			this.$vmodal.open({
				component: require("./modals/CallLog.vue").default,
				props: {
					calls: this.client.group.calls,
				},
			});
		},
		showNotesModal(newTab = false) {
			this.$vmodal.open({
				component: require("./modals/Notes.vue").default,
				props: {
					notes: this.client.group.notes,
					newTab: newTab,
					url: this.route("clients/:client/note", this.client),
					then: (response) => {
						this.$vmodal.close();
						this.eventBus.$handle("noteAdded", response.data);
					},
				},
			});
		},
		showToDosModal(newTab = false) {
			this.$vmodal.open({
				component: require("./modals/Todos.vue").default,
				props: {
					todos: this.client.group.todos,
					newTab: newTab,
					url: this.route("clients/:client/to-do", this.client),
					then: (response) => {
						this.$vmodal.close();
						this.eventBus.$handle("toDoAdded", response.data);
					},
				},
			});
		},
	},

	props: {
		client: {
			required: true,
			type: Object,
		},
	},
};
</script>
